section.current {
  display: flex;
  align-items: center;
  box-sizing: border-box;
  padding: 0 var(--size-2) 0 0;
  height: var(--pos-navigation-bar-height);
  flex-grow: 1;
  gap: 0;
  background-color: var(--pos-input-background-color);
  border-radius: var(--radius-md);
  width: 100%;
  &:focus-within {
    outline: var(--pos-input-focus-outline);
  }

  button {
    cursor: pointer;
    font-size: var(--scale-1);
    display: flex;
    align-items: center;
    justify-content: center;
    flex-grow: 1;
    background: none;
    color: var(--pos-normal-text-color);
    outline: none;
    border: none;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    &:focus {
      text-decoration: underline;
    }
    :first-child {
      flex-grow: 1;
    }
    svg {
      width: var(--size-6);
      color: var(--pos-subtle-text-color);
    }
  }
  pos-share {
    height: 80%;
    &:hover {
      &::part(button) {
        color: var(--pos-primary-color);
        background-color: var(--pos-border-color);
        border-radius: var(--radius-full);
      }
    }
    &::part(button) {
      font-size: var(--size-4);
      background: none;
      outline: none;
      border: none;
      color: var(--pos-subtle-text-color);
    }
  }
}
